import { API_URLS } from "../../constants";
import apiClient from "../../utils/interceptor";
import { encryptAES } from '../../utils/crypto';

export const login = async (loginParams) => {
    try {
        const secretKey = process.env.REACT_APP_SECRET_KEY || "";
        const encryptedData = await encryptAES(loginParams.password, secretKey);
        const loginPayloadParams = {
            user_name: loginParams.user_name,
            iv_hex: encryptedData.iv,
            encrypted_hex: encryptedData.encrypted,
        };

        const response = await apiClient.post(API_URLS.AUTH.LOGIN, loginPayloadParams);
        return response.data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

export const changePassword = async (changePasswordParams) => {
    try {
        const secretKey = process.env.REACT_APP_SECRET_KEY || "";
        const oldEncryptedData = await encryptAES(changePasswordParams.old_password, secretKey);

        const changePasswordPayloadParams = {
            user_name: changePasswordParams.user_name,
            iv_hex_old: oldEncryptedData.iv,
            encrypted_hex_old: oldEncryptedData.encrypted,
            new_password: changePasswordParams.new_password,
        };

        const response = await apiClient.post(
            API_URLS.AUTH.CHANGE_PASSWORD,
            changePasswordPayloadParams
        );

        return response.data;
    } catch (error) {
        console.error("Error changing password:", error);
        throw error;
    }
};

export const resetPassword = async (resetPasswordParams) => {
    try {
        const response = await apiClient.post(
            API_URLS.AUTH.RESET_PASSWORD,
            resetPasswordParams
        );
        return response.data;
    } catch (error) {
        console.error("Error resetting password:", error);
        throw error;
    }
};
